
































import Modal from "../core/Modals/Modal.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { RecurrenceInterventionApi } from "../api/RecurrenceInterventionApi";
import RemplacementModalEdit from "./RemplacementModalPartials/RemplacementModalEdit.vue";
import { RecurrenceIntervention } from "../models/RecurrenceIntervention";
import Remplacement = RecurrenceIntervention.Remplacement;
import { Employe } from "../models/Employe";
import Tabs from "../core/Tabs/Tabs.vue";
import Tab from "../core/Tabs/Tab.vue";
import RemplacementModalInterventionsEdit from "./RemplacementModalPartials/RemplacementModalInterventionsEdit.vue";

export default {
    name: "RemplacementModal",
    components: {
        RemplacementModalInterventionsEdit,
        Tab,
        Tabs,
        RemplacementModalEdit,
        EditionModal,
        Modal,
    },
    props: {
        recurrenceInterventionIds: Array,
        remplacement: Remplacement,
        isNew: Boolean,
        defaultEmploye: Object,
    },
    data() {
        return {
            showModal: false,
            editingRemplacement: null,
            savedRemplacement: null,
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
        };
    },
    created() {
        var self = this;
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
            this.$emit("close-modal", this.savedRemplacement);
        },
        saveRemplacement: function (): Promise<Remplacement> {
            let self = this;
            if (!self.editingRemplacement.isValid()) {
                swal(
                    "Erreur lors de la sauvegarde.",
                    "Certains champs sont incomplets ou erronés.",
                    "error"
                );
                return;
            }

            if (self.recurrenceInterventionIds) {
                self.editingRemplacement.recurrence_interventions_ids =
                    self.recurrenceInterventionIds;
            }

            return self.RecurrenceInterventionApi.saveRemplacement(
                self.editingRemplacement
            ).then(function (res) {
                self.savedRemplacement = res;
                _.each(
                    self.editingRemplacement.recurrence_interventions_ids,
                    function (recurrenceInterventionId) {
                        self.RecurrenceInterventionApi.resetInterventionRecurrente(
                            recurrenceInterventionId,
                            res.start_date_str
                        );
                    }
                );
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.create = true;
            this.savedRemplacement = null;
            if (this.defaultEmploye) {
                if (this.defaultEmploye instanceof Employe) {
                    this.editingRemplacement.replaced_employe =
                        this.defaultEmploye;
                } else {
                    this.editingRemplacement.replaced_employe = new Employe(
                        this.defaultEmploye
                    );
                }
            }
        },
    },
    watch: {
        remplacement: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.editingRemplacement = _.cloneDeep(newVal);
                    this.showModal = true;
                    this.create = false;
                    this.savedRemplacement = null;
                }
            },
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.editingRemplacement = new Remplacement({});
                    this.creationModal();
                }
            },
        },
    },
};
